import { Link } from 'react-router-dom';
import { useTranslation } from '@/lib/i18n';
import { useTheme } from '@/lib/ThemeContext';

export default function Footer() {
    const { t, language } = useTranslation();
    const { themeMode } = useTheme();
    const isV2 = themeMode === 'v2';

    return (
        <footer className={`mt-24 py-12 border-t transition-colors ${
            isV2 ? 'border-slate-800/50 bg-slate-900/10' : 'border-slate-100 bg-slate-50/30'
        }`}>
            <div className="max-w-4xl mx-auto px-6">
                <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8">
                    <Link to="/help" className={`transition-all text-sm font-medium ${
                        isV2 ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
                    }`}>
                        {t('nav.help')}
                    </Link>
                    {/* 'For kommuner' er skjult fra publikum etter brukerens ønske */}
                    <Link to="/about" className={`transition-all text-sm font-medium ${
                        isV2 ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
                    }`}>
                        {t('about.title')}
                    </Link>
                    <Link to="/contact" className={`transition-all text-sm font-medium ${
                        isV2 ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
                    }`}>
                        {t('contact.title')}
                    </Link>
                    <Link to="/legal/terms" className={`transition-all text-sm font-medium ${
                        isV2 ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
                    }`}>
                        {t('legal.terms')}
                    </Link>
                    <Link to="/legal/privacy" className={`transition-all text-sm font-medium ${
                        isV2 ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
                    }`}>
                        {t('legal.privacy')}
                    </Link>
                    <Link to="/legal/accessibility" className={`transition-all text-sm font-medium ${
                        isV2 ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
                    }`}>
                        {language === 'no' ? 'Tilgjengelighet' : 'Accessibility'}
                    </Link>
                </div>

                <div className="flex flex-col items-center space-y-2">
                    <p className={`text-[11px] font-medium tracking-tight text-center ${
                        isV2 ? 'text-slate-500' : 'text-slate-400'
                    }`}>
                        &copy; {new Date().getFullYear()} TipsNorge. {t('legal.copyright')}
                        <span className="block mt-1 sm:inline sm:mt-0 sm:ml-2">
                            {language === 'no' ? 'Behandlingsansvarlig: ' : 'Data controller: '}
                            <span className="font-semibold">Khan Creatives</span>
                        </span>
                    </p>
                    <div className={`h-px w-8 rounded-full ${isV2 ? 'bg-slate-800' : 'bg-slate-200'}`} />
                </div>
            </div>
        </footer>
    );
}

